import { Children, ReactNode } from 'react';
import { Grid } from '@mui/material';

export type InfoFieldRowProps = {
  children: ReactNode;
  cols?: number;
};

export const InfoFieldRow = ({ children, cols = 4 }: InfoFieldRowProps) => {
  return (
    <Grid container spacing={3}>
      {Children.map(children, (child) =>
        child ? (
          <Grid item xs={12} sm={6} md={12 / cols}>
            {child}
          </Grid>
        ) : null,
      )}
    </Grid>
  );
};
